import { getCurrencySymbol } from "../../../utils/currencySymbols";
import { useState, useEffect } from "react";

const validatePrice = (value, t) => {
  if (value === "" || value === undefined || value === null) {
    return t ? t("validation_price_required") : "Price is required";
  }

  // Special characters not allowed
  if (/[^0-9.]/.test(value)) {
    return t
      ? t("validation_price_special_chars")
      : "Special characters are not allowed";
  }

  // More than one decimal not allowed
  if ((value.match(/\./g) || []).length > 1) {
    return t ? t("validation_price_invalid") : "Invalid price format";
  }

  // Max 6 digits + optional 2 decimal places
  if (!/^\d{1,6}(\.\d{1,2})?$/.test(value)) {
    return t
      ? t("validation_price_max_6_digits")
      : "Maximum 6 digits allowed with up to 2 decimals";
  }

  const num = Number(value);

  if (isNaN(num)) {
    return t ? t("validation_price_invalid") : "Invalid price";
  }

  if (num <= 0) {
    return t ? t("validation_price_positive") : "Price must be greater than 0";
  }

  return null;
};

const ServiceTableRow = ({
  service,
  index,
  currencyCode,
  onRemove,
  canRemove,
  onPriceChange,
  canEdit = true,
  t,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempPrice, setTempPrice] = useState("");
  const [priceError, setPriceError] = useState("");

  useEffect(() => {
    setTempPrice(
      service.price !== undefined && service.price !== null
        ? Number(service.price).toFixed(2)
        : "",
    );
  }, [service.price, service.id]);

  const enterEdit = () => {
    setTempPrice(
      service.price !== undefined && service.price !== null
        ? Number(service.price).toFixed(2)
        : "",
    );
    setIsEditing(true);
  };

  const handleSave = () => {
    const error = validatePrice(tempPrice, t);
    setPriceError(error);
    if (error) return;
    onPriceChange(service.id || service.serviceId, tempPrice);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setTempPrice(
      service.price !== undefined && service.price !== null
        ? Number(service.price).toFixed(2)
        : "",
    );
    setIsEditing(false);
    setPriceError("");
  };

  return (
    <tr>
      {/* TYPE */}
      <td
        className="border-0"
        style={{
          backgroundColor: service.status === 3 ? "#f5f5f5" : "transparent",
        }}
      >
        <span
          className={`tag-border ${
            service.type === "oem"
              ? "teal-text"
              : service.type === "recommended"
                ? "blue-text"
                : service.type === "optional"
                  ? "green-text"
                  : "gray-text"
          }`}
        >
          {service.type === "oem"
            ? "O"
            : service.type === "recommended"
              ? "R"
              : "O"}
        </span>
      </td>

      {/* NAME */}
      <td
        className="border-0"
        style={{
          backgroundColor: service.status === 3 ? "#f5f5f5" : "transparent",
        }}
      >
        <div>
          <div>
            {service.serviceName || service.displayName || t("service")}
          </div>
          {service.status === 3 && (
            <div
              style={{
                display: "inline-block",
                backgroundColor: "#e0e0e0",
                color: "#666666",
                fontSize: "0.7em",
                marginTop: "4px",
                fontWeight: "400",
                padding: "2px 8px",
                borderRadius: "3px",
              }}
            >
              {t ? t("declined").toUpperCase() : "DECLINED"}
            </div>
          )}
        </div>
      </td>

      {/* PRICE */}
      <td
        className="border-0 text-nowrap"
        style={{
          backgroundColor: service.status === 3 ? "#f5f5f5" : "transparent",
        }}
      >
        {service.price !== undefined ? (
          service.status === 3 || !isEditing ? (
            <span>
              {getCurrencySymbol(currencyCode)}
              {Number(service.price).toFixed(2)}
            </span>
          ) : (
            <div className="d-flex flex-column align-items-start gap-1">
              <div className="d-flex align-items-center gap-1">
                <input
                  type="text"
                  className={`form-control form-control-sm shadow-none${
                    priceError ? " is-invalid" : ""
                  }`}
                  style={{ width: "130px" }}
                  value={tempPrice}
                  onChange={(e) => {
                    const val = e.target.value;

                    setTempPrice(val);

                    if (priceError) {
                      setPriceError(validatePrice(val, t));
                    }
                  }}
                />
                <i
                  className="fas fa-check text-success"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={handleSave}
                ></i>
                <i
                  className="fas fa-times text-danger"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={handleCancel}
                ></i>
              </div>
              {priceError && (
                <div
                  className="invalid-feedback d-block"
                  style={{ fontSize: "12px" }}
                >
                  {priceError}
                </div>
              )}
            </div>
          )
        ) : (
          t("price_on_request")
        )}
      </td>

      {/* ACTIONS */}
      <td
        className="border-0 text-center"
        style={{
          backgroundColor: service.status === 3 ? "#f5f5f5" : "transparent",
        }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          {canEdit &&
            !isEditing &&
            service.price !== undefined &&
            service.status !== 3 && (
              <i
                className="fas fa-pen text-muted"
                style={{
                  fontSize: "14px",
                  cursor: "pointer",
                }}
                onClick={enterEdit}
              ></i>
            )}

          {canRemove && service.status !== 3 && (
            <button
              onClick={() =>
                onRemove && onRemove(service.id || service.serviceId)
              }
              className="btn p-0 border-0 bg-transparent shadow-none"
            >
              <img
                src="/assets/images/icons/delete-icon.svg"
                alt={t("remove_alt")}
                style={{
                  width: "16px",
                  height: "16px",
                }}
              />
            </button>
          )}
        </div>
      </td>
    </tr>
  );
};

export default ServiceTableRow;
